import { selectStaticResidentialProxies } from 'store/slices/PricingSlice';
import Plan from '../../Plan';
import { useSelector } from 'react-redux';
import { selectProductCalc } from 'store/slices/GeneralSlice';

const StaticPlan = () => {
    const data = useSelector(selectStaticResidentialProxies);
    const { products } = useSelector(selectProductCalc)
    if (!products) return
    const currentProduct = products?.find(item => item.unique_id === data.product_id);
    if (!currentProduct) return

    return <Plan list={currentProduct.description_items} title={currentProduct.description_title} />;
};

export default StaticPlan;
